import { render, staticRenderFns } from "./CommentMark.vue?vue&type=template&id=08010c1e&scoped=true"
import script from "./CommentMark.vue?vue&type=script&lang=js"
export * from "./CommentMark.vue?vue&type=script&lang=js"
import style0 from "./CommentMark.vue?vue&type=style&index=0&id=08010c1e&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "08010c1e",
  null
  
)

export default component.exports